import React from "react";

interface TextareaFieldProps {
  name?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  leadingIcon?: React.ReactNode;
  className?: string;
  rows?: number;
  maxLength?: number;
}

const TextareaField: React.FC<TextareaFieldProps> = ({
  name,
  value,
  onChange,
  placeholder,
  leadingIcon,
  className = "",
  rows = 5,
  maxLength,
}) => {
  if (leadingIcon != null) {
    return (
      <div className="w-full relative">
        <div className="absolute left-3 top-4 pointer-events-none">
          {leadingIcon}
        </div>
        <textarea
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          rows={rows}
          className={
            "pl-10 pr-3 py-2 text-gray-500 placeholder-gray-400 border border-[#C72BA4] hover:border-[#EA33C0] focus:ring-[#C72BA4] focus:border-2 rounded-lg focus:outline-none bg-white transition duration-200 placeholder:text-sm resize-none " +
            className
          }
          maxLength={maxLength}
        />
      </div>
    );
  }

  return (
    <textarea
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      className={
        "px-3 py-2 border border-[#C72BA4] hover:border-[#EA33C0] focus:ring-[#C72BA4] focus:border-2 rounded-lg focus:outline-none transition duration-200 placeholder:text-sm resize-none " +
        className
      }
    />
  );
};

export default TextareaField;
